import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { SitesEditPageRoutingModule } from "./sites-edit-routing.module";

import { SitesEditPage } from "./sites-edit.page";
import { AdjustFontSizePipe } from "../pipes/adjustFontSize.pipe";

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, SitesEditPageRoutingModule],
  declarations: [SitesEditPage, AdjustFontSizePipe],
  exports: [AdjustFontSizePipe],
})
export class SitesEditPageModule {}
